import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface CountdownLoaderProps {
  seconds: number;
  onComplete?: () => void;
}

export const CountdownLoader = ({
  seconds,
  onComplete,
}: CountdownLoaderProps) => {
  const { t } = useTranslation();
  const [remainingTime, setRemainingTime] = useState(seconds);
  const [isCompleted, setIsCompleted] = useState(false);

  useEffect(() => {
    if (remainingTime <= 0) {
      setIsCompleted(true);
      onComplete?.();
      return;
    }

    const timer = setInterval(() => {
      setRemainingTime((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [remainingTime, onComplete]);

  if (isCompleted) {
    return (
      <>
        <div className="tw-w-16 tw-h-16 tw-border-4 tw-border-gray-300 tw-border-t-blue-400 tw-rounded-full tw-animate-spin tw-mb-6"></div>
        <div className="tw-text-lg tw-font-bold tw-text-primary">
          {t('components.countdown_loader.almost_ready')}
        </div>
      </>
    );
  }

  return (
    <>
      <div className="tw-w-16 tw-h-16 tw-border-4 tw-border-gray-300 tw-border-t-blue-400 tw-rounded-full tw-animate-spin tw-mb-6"></div>
      <div className="tw-text-lg tw-text-center tw-text-primary">
        {t('components.countdown_loader.requisite_in')}{' '}
        <span className="tw-font-bold tw-text-blue-400">{remainingTime}</span>{' '}
        {t('components.countdown_loader.seconds')}
      </div>
    </>
  );
};
